import React, { useState } from 'react';
import { Facebook, Twitter, MessageCircle, Link2, Check } from 'lucide-react';

// Social share row for an article. Uses the live page URL so links work in any environment.
const ShareButtons = ({ title }) => {
  const [copied, setCopied] = useState(false);
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const url = encodeURIComponent(pageUrl);
  const text = encodeURIComponent(title || 'DCTV story');

  const links = [
    { key: 'whatsapp', label: 'Share on WhatsApp', Icon: MessageCircle, href: `https://wa.me/?text=${text}%20${url}` },
    { key: 'x', label: 'Share on X', Icon: Twitter, href: `https://twitter.com/intent/tweet?text=${text}&url=${url}` },
    { key: 'facebook', label: 'Share on Facebook', Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${url}` },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div data-testid="share-buttons" className="flex items-center gap-3 flex-wrap">
      <span className="dctv-eyebrow text-[#9aa3b2]">Share</span>
      {links.map(({ key, label, Icon, href }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`share-${key}`}
          className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#9aa3b2] hover:text-[#e8743b] hover:border-[#e8743b]/50 transition-colors"
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label="Copy link"
        data-testid="share-copy-link"
        className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-[#9aa3b2] hover:text-[#e8743b] hover:border-[#e8743b]/50 transition-colors"
      >
        {copied ? <Check className="w-4 h-4 text-[#5cc98a]" /> : <Link2 className="w-4 h-4" />}
      </button>
      {copied && <span data-testid="share-copied-msg" className="text-[#5cc98a] text-xs">Link copied</span>}
    </div>
  );
};

export default ShareButtons;
